<template>
  <field-facility-complex-list
    :breadcrumb="[{ title: 'Home' }, { title: '중대시민재해 대상시설 현황' }, { title: '공중이용시설' }, { title: '어린이집', active: true }]"
    :field-code="fieldCode"
    @update-field-list="updateFieldList"
    :columns="columns"
    :table-list="tableList"
  />
</template>

<script>
import FieldFacilityComplexList from "@/views/_BS/FieldFacilityComplexList.vue";

export default {
  components: {FieldFacilityComplexList},
  data()  {
    return {
      fieldCode: 'daycare',
      fieldList: [],
      columns: [
        { style: {width: "80px"}, spanClass: ['w-full', 'text-center'], label: "No."},
        { style: {minWidth: "130px"}, spanClass: ['w-full', 'text-center'], label: "시설물번호"},
        { style: {minWidth: "130px"}, spanClass: ['w-full', 'text-center'], label: "시설물명"},
        { style: {minWidth: "130px"}, spanClass: ['w-full', 'text-center'], label: "관리주체"},
        { style: {minWidth: "130px"}, spanClass: ['w-full', 'text-center'], label: "준공일"},
        { style: {minWidth: "130px"}, spanClass: ['w-full', 'text-center'], label: "총공사비"},
        { style: {minWidth: "130px"}, spanClass: ['w-full', 'text-center'], label: "주소"},
      ],
      tableList: [],
    }
  },
  created() {
    // 메뉴 활성화를 위해서, 라우트에 설정된 activeCode 값을 갱신한다
    // this.$route.meta.activeCode = `complex-${this.fieldCode}`;
  },
  methods: {
    updateFieldList(fieldList) {
      if (!fieldList.data) {
        this.tableList = [];
        return;
      }

      this.tableList = fieldList.data.map((item) => {
        if (typeof item.meta === 'string') {
          item.meta = JSON.parse(item.meta);
        }
        const rowData = [];
        rowData.push({ class: ["text-center"], value: item.id, });
        rowData.push({ class: ["text-center"], value: item.meta.facilityNumber, });
        rowData.push({ class: ["text-center"], value: item.field_name, });
        rowData.push({ class: ["text-center"], value: item.meta.management_entity ? item.meta.management_entity : "-", });
        rowData.push({ class: ["text-center"], value: item.be_completed_at ? item.be_completed_at : "-", });
        rowData.push({ class: ["text-center"], value: item.deposit_amount ? `${item.deposit_amount  }백만원` : "-", });
        rowData.push({ class: ["text-center"], value: item.address ? item.address : "-", });

        return {
          id: item.id,
          tds: rowData,
        };
      });
    }
  }
}
</script>

<style scoped>

</style>
